import React, { useEffect } from 'react';
import { useNavigate, NavLink } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import Navbar from './Navbar';
import Hero from './Hero';
import LaunchMetricsStrip from './LaunchMetricsStrip';
import LaunchBentoGrid from './LaunchBentoGrid';
import ProductLaunchShowcase from './ProductLaunchShowcase';
import SaasProductFlow from './SaasProductFlow';
import Reviews from './Reviews';
import PricingPlans from './PricingPlans';
import ContactForm from './ContactForm';
import Footer from './Footer';
import { LandingSectionShell } from './LandingSectionShell';
import { HeroBackground } from './HeroBackground';
import { PRODUCT_NAME, PRODUCT_TAGLINE } from '../../lib/tenant';

function LandingPage() {
  const navigate = useNavigate();

  useEffect(() => {
    const isLoggedIn = localStorage.getItem('isLoggedIn') === 'true';
    if (isLoggedIn) {
      navigate('/dashboard');
    }
  }, [navigate]);

  return (
    <div className="relative min-h-screen bg-[#030712] font-sans text-zinc-100 antialiased">
      <HeroBackground variant="fixed" />

      <div className="relative z-10">
        <Navbar />
        <Hero />
        <LaunchMetricsStrip />
        <LaunchBentoGrid />
        <ProductLaunchShowcase />
        <SaasProductFlow />
        <Reviews />
        <PricingPlans />

        <LandingSectionShell className="!py-20">
          <div className="container mx-auto flex flex-col items-center gap-8 px-4 text-center md:flex-row md:justify-between md:text-left">
            <motion.div
              initial={{ opacity: 0, y: 16 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              className="max-w-xl"
            >
              <p className="text-xs font-bold uppercase tracking-[0.2em] text-emerald-400">{PRODUCT_TAGLINE}</p>
              <h2 className="mt-3 font-display text-3xl font-semibold tracking-tight text-white sm:text-4xl">
                Go live with {PRODUCT_NAME} tomorrow
              </h2>
              <p className="mt-3 text-base leading-relaxed text-slate-400">
                Register your organization, create branch ledgers, choose a plan, and start collecting — finance desk,
                reports, and WhatsApp reminders included from day one.
              </p>
            </motion.div>
            <div className="flex flex-col gap-3 sm:flex-row">
              <NavLink
                to="/register?plan=pro"
                className="inline-flex items-center justify-center gap-2 rounded-2xl bg-gradient-to-r from-emerald-500 to-teal-600 px-8 py-4 text-base font-semibold text-white shadow-xl shadow-emerald-900/40 transition-transform hover:-translate-y-0.5"
              >
                Start free trial
                <ArrowRight className="h-5 w-5" />
              </NavLink>
              <NavLink
                to="/login"
                className="inline-flex items-center justify-center rounded-2xl border border-white/15 bg-white/5 px-8 py-4 text-base font-semibold text-white backdrop-blur-sm hover:bg-white/10"
              >
                Sign in
              </NavLink>
            </div>
          </div>
        </LandingSectionShell>

        <ContactForm />
        <Footer />
      </div>
    </div>
  );
}

export default LandingPage;
